var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.70264,
    r: 1.5,
    fill: "#676C88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 7.70264,
    r: 1.5,
    fill: "#676C88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 13.7026,
    r: 1.5,
    fill: "#676C88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 1.70264,
    r: 1.5,
    fill: "#676C88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.70264,
    r: 1.5,
    fill: "#676C88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.7026,
    r: 1.5,
    fill: "#676C88"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdination);
export default __webpack_public_path__ + "static/media/ordination.403eb26f351800098b9f5e678095c1a7.svg";
export { ForwardRef as ReactComponent };